module.exports = __webpack_public_path__ + "img/goods12_3.b3a11114.jpg";